import { render } from "./NotificacionesList.vue?vue&type=template&id=865b4ff6"
import script from "./NotificacionesList.vue?vue&type=script&lang=js"
export * from "./NotificacionesList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__